import { createTheme } from "@mui/material/styles";
import { faIR } from "@mui/x-date-pickers/locales";

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    type: "light",
    primary: {
      main: window.ENV.primary,
      light: "#fff",
      contrastText: window.ENV.contrastTextPrimary,
    },
    secondary: {
      main: window.ENV.secondary,
      contrastText: window.ENV.contrastTextSecondary,
    },
  },
  faIR,
  direction: "rtl",
  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",

        autoComplete: "off",
        InputProps: {
          autoComplete: "off",
          inputProps: {
            min: 1,
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
    },
    MuiIcon: {
      defaultProps: {
        fontSize: "small",
      },
    },
    MuiDataGrid: {
      defaultProps: {
        sx: {
          outline: "0px !important",

          "&  .MuiDataGrid-filterIcon": {
            display: "none",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "&  .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "&  .MuiDataGrid-cell:focus-within ": {
            outline: "0px !important",
          },
          "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "0px !important",
          },
          "& .MuiDataGrid-cell:hover": {
            color: "primary.main",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !important",
          },
        },
      },
    },
  },
});

export default theme;
